import apiClient from "../../client/apiClient"

export interface AreaOption {
  value: string
  label: string
}

export const getAreas = async (): Promise<AreaOption[]> => {
  const response = await apiClient({ url: "/transport/areas", method: "GET" })
  return response.data
}
